import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

import sessionStorage from 'redux-persist/lib/storage/session';

import userSlice from './userSlice';
import searchSlice from './searchSlice';

const persistConfig = {
  key: 'root',
  storage,
};

// Search filters live only for the browser tab's session
const searchPersistConfig = {
  key: 'search',
  storage: sessionStorage,
};

const persistedUserReducer = persistReducer(persistConfig, userSlice);
const persistedSearchReducer = persistReducer(searchPersistConfig, searchSlice);

export const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    search: persistedSearchReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

